export type ArchitectDesignCommentScope = {
  projectId: string;
  dealId: string;
};

function scopeKey(scope: ArchitectDesignCommentScope): string {
  return `${scope.projectId}::${scope.dealId}::design`;
}

/** Build listen scopes from granted timber projects (needs dealId). */
export function architectDesignCommentScopesFromProjects(
  projects: Array<{ id?: string; dealId?: string | null }>,
): ArchitectDesignCommentScope[] {
  const scopes: ArchitectDesignCommentScope[] = [];
  const seen = new Set<string>();
  for (const project of projects) {
    const projectId = (project.id || '').trim();
    const dealId = (project.dealId || '').trim();
    if (!projectId || !dealId) continue;
    const key = `${projectId}::${dealId}`;
    if (seen.has(key)) continue;
    seen.add(key);
    scopes.push({ projectId, dealId });
  }
  scopes.sort((a, b) => scopeKey(a).localeCompare(scopeKey(b)));
  return scopes;
}

export function architectDesignCommentScopeKey(scope: ArchitectDesignCommentScope): string {
  return scopeKey(scope);
}
